<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="w-5 h-5 text-gray-700"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fill-rule="evenodd"
      d="M12.707 15.707a1 1 0 01-1.414 0L6.586 11l4.707-4.707a1 1 0 011.414 1.414L9.414 11l3.293 3.293a1 1 0 010 1.414z"
      clip-rule="evenodd"
    />
  </svg>
</template>
